import { createSelector } from '@reduxjs/toolkit';

import { CompPropertyDataState, RootState } from '../../../types.ts';
import { propertyDataAdapter } from '../../propertyDataAdapter.ts';

export const {
  selectEntities: selectPropertyDataEntities,
  selectAll: selectAllPropertyData,
  selectById: selectPropertyDataById,
} = propertyDataAdapter.getSelectors((state: RootState) => state.propertyData);

export const selectPropertyDataCompTypes = createSelector(
  [selectPropertyDataEntities],
  (propertyDataEntities) => {
    const compTypes: Record<string, string | undefined> = {};
    Object.values(propertyDataEntities).forEach((propertyData) => {
      if (!propertyData) return;
      if (propertyData.id === 'subject') return;
      const compData = propertyData as CompPropertyDataState;
      compTypes[compData.id] = compData.compData?.compType;
    });
    return compTypes;
  },
);
